import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { Button } from 'twyne-new.ui';

import { useGrid } from '@Components/Grid/context';
import { useGlobalAuthStore } from '@Stores/global/auth';

export default function HeaderButtons() {
  const { auth: { isSuperAdmin } } = useGlobalAuthStore()
  const { definitions: { entityNameModule, entityNamePlural, entityName, basePath } } = useGrid()

  const path = useMemo(() => {
    if (basePath) {
      return basePath;
    }
    return `/${entityNameModule}/${entityNamePlural.toLowerCase()}`
  }, [basePath, entityNamePlural, entityNameModule])

  if (!isSuperAdmin) {
    return null
  }

  return <Button color='accent' size='lg' asChild>
    <Link to={`${path}/add`} className="btn btn-outline-success">
      New {entityName}
    </Link>
  </Button>
}
